const ORDER_PARAMS_TYPE_TO_SESSION = {
  PickAtStore: 'picked',
  ShipFromStore: 'shipped',
  AllStores: 'allstoreorder',
};

// FCM data map is Map<String,String>, so `payload` aata hai JSON string ki tarah.
const parseNotificationPayload = (rawPayload) => {
  if (!rawPayload) return null;
  if (typeof rawPayload === 'object') return rawPayload;
  if (typeof rawPayload !== 'string') return null;
  try {
    const parsed = JSON.parse(rawPayload);
    return parsed && typeof parsed === 'object' ? parsed : null;
  } catch (e) {
    console.warn('[notification] Failed to parse payload:', e);
    return null;
  }
};

// landingurl kabhi data pe hota hai, kabhi payload ke andar.
export const getNotificationLandingUrl = (data) => {
  if (!data || typeof data !== 'object') return '';
  const url = data.landingurl || parseNotificationPayload(data.payload)?.landingurl;
  return typeof url === 'string' && url.trim() ? url.trim() : '';
};

// QUICK_ASSIST notification ka ticketId session me store karo (navigate se pehle).
export const applyQuickAssistTicketId = (data) => {
  if (!data || typeof data !== 'object') return;
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return;
  if (data.type !== 'QUICK_ASSIST') return;
  const payload = parseNotificationPayload(data.payload);
  if (!payload?.ticketId) return;
  // ticketId "TK-1322" jaisa aata hai, session me sirf number chahiye -> "1322".
  const raw = String(payload.ticketId);
  const digits = raw.replace(/\D/g, '');
  sessionStorage.setItem('fcmquickassitticketid', digits || raw);
};

export const applyOrderTypeFromUrl = (rawUrl) => {
  if (!rawUrl || typeof rawUrl !== 'string') return;
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') return;
  try {
    const parsed = new URL(rawUrl, window.location.origin);
    const orderParamsType = parsed.searchParams.get('orderParams_type');
    if (!orderParamsType) return;
    const mapped = ORDER_PARAMS_TYPE_TO_SESSION[orderParamsType];
    if (!mapped) return;
    sessionStorage.setItem('OrderType', mapped);
  } catch (e) {
    console.warn('[notification] Failed to parse landing URL:', e);
  }
};
